// History Page — Customer booking history (Firestore-backed)
import { renderHeader, renderBottomNav } from '../components/header.js';
import { renderBookingCard, bindBookingActions } from '../components/booking-card.js';
import { toastSuccess } from '../components/toast.js';
import { getCurrentUser } from '../auth.js';
import { isFirebaseReady } from '../firebase.js';
import { getBookingsByUser, updateBookingDB } from '../services/db.js';
import { notifyBookingCancelled } from '../services/api.js';
import { demoBookings, updateDemoBooking } from '../data/demo-store.js';
import { t } from '../i18n.js';
import { showConfirm } from '../utils/dialog.js';

export async function renderHistory() {
  const user = getCurrentUser();
  const app = document.getElementById('app');

  // Show loading
  app.innerHTML = `
    ${renderHeader()}
    <div class="page">
      <h2 class="page-title">${t('history_title')}</h2>
      <div style="text-align:center; padding: var(--space-xl);">
        <div class="loading-spinner"></div>
      </div>
    </div>
    ${renderBottomNav('history')}
  `;

  // Load bookings
  const myBookings = isFirebaseReady()
    ? await getBookingsByUser(user.id)
    : demoBookings.filter(b => b.user_id === user.id);

  app.innerHTML = `
    ${renderHeader()}
    <div class="page">
      <h2 class="page-title">${t('history_title')}</h2>
      
      <div id="history-list">
        ${myBookings.length > 0
      ? myBookings.map(b => renderBookingCard(b)).join('')
      : `
          <div class="empty-state">
            <div class="empty-state-icon">📭</div>
            <div class="empty-state-title">Not Found</div>
            <div class="empty-state-text">Explore our services and book a session.</div>
          </div>
        `}
      </div>
    </div>
    ${renderBottomNav('history')}
  `;

  // Bind cancel actions
  const listContainer = document.getElementById('history-list');
  if (listContainer) {
    bindBookingActions(listContainer, {
      onCancel: async (id) => {
        if (await showConfirm('ต้องการยกเลิกการจองนี้?')) {
          const booking = myBookings.find(b => b.id === id);
          if (isFirebaseReady()) {
            await updateBookingDB(id, { status: 'cancelled' });
            if (booking) await notifyBookingCancelled(booking);
          } else {
            updateDemoBooking(id, { status: 'cancelled' });
          }
          toastSuccess('ยกเลิกการจองแล้ว');
          renderHistory();
        }
      }
    });
  }
}
